<div class="p-grid">
  <div class="p-col-12 mu-without-padding" [id]="mapPositionEnum.TOP"></div>
</div>
<div class="p-grid mu-layout-columns" [ngClass]="{ 'mu-layout-columns-service': isRequestService }">
  <div
    class="p-col-12 p-lg-{{
      columnSize?.startColumn ? columnSize?.startColumn : 6
    }} card mu-layout-column mu-layout-column-content {{ layoutContentClass }}"
  >
    <div class="mu-mobile-placeHolder mu-mobile-map" #muTopMobilePlaceHolder></div>
    <app-mu-section-title
      [icon]="texts?.icon"
      [title]="texts?.title"
      [subTitle]="texts?.subTitle"
      *ngIf="texts?.title !== ''"
    ></app-mu-section-title>
    <div #muMapMobileFragmentTopPlaceHolder></div>
    <div #muMobilePlaceHolder class="mu-mobile-map"></div>
    <div #muMapMobileFragmentBottomPlaceHolder></div>
    <router-outlet></router-outlet>
  </div>
  <div
    class="p-col-12 p-lg-{{
      columnSize?.endColumn ? columnSize?.endColumn : 6
    }} mu-layout-column mu-map-fragment"
    (mouseleave)="checkToFitBounds()"
  >
    <div #muMapFragmentTopPlaceHolder></div>
    <div
      #muDesktopPlaceHolder
      class="layout-map-fragment p-col-12 p-lg-{{
        columnSize?.endColumn ? columnSize?.endColumn : 6
      }}"
    ></div>
    <div #muMapFragmentBottomPlaceHolder></div>
  </div>
</div>

<app-mu-map
  class="mu-position-relative"
  #muMap
  [mapType]="atlasType"
  [mapOptions]="mapOptions"
  (eventComponentReady)="onComponentReady($event)"
  *ngIf="atlasType"
>
  <app-mu-button
    *ngIf="buttonFlagList"
    id="mu-map-button"
    label="{{ 'form.button.tutorial' | translate }}"
    [disabled]="buttonDisabled"
  ></app-mu-button>
  <app-mu-alert
    [styles]="'warning'"
    [message]="'alert.express.warning'"
    [showAlert]="showAlertScheduleMx"
  ></app-mu-alert>
</app-mu-map>

<app-mu-modal-dialog-layout
  id="mu-modal-dialog-position"
  [title]="'modalPosition.title' | translate"
  [subTitleValue]="'modalPosition.description' | translate"
  [icon]="'fa-map-marker-alt'"
  [flagList]="flagList"
  [showFlag]="LayoutPageAndMapModalPositionFlags.SHOW_MODAL_POSITION"
  [showCloseIcon]="true"
  [hideLine]="true"
></app-mu-modal-dialog-layout>